import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const serviceItems = [
  {
    id: 1,
    icon: '/images/icon/fine-ticket.svg',
    name: '罰單',
    url: 'FineTicket',
  },
  {
    id: 2,
    icon: '/images/icon/parking-fee.svg',
    name: '停車費',
    url: 'ParkingFee',
  },
  { id: 3, icon: '/images/icon/etag.svg', name: 'ETag', url: 'ETag' },
  {
    id: 4,
    icon: '/images/icon/appointment.svg',
    name: '預約記錄',
    url: 'Appointment',
  },
  {
    id: 5,
    icon: '/images/icon/maintenance.svg',
    name: '保養預約',
    url: 'Maintenance',
  },
  {
    id: 6,
    icon: '/images/icon/Inspection.svg',
    name: '驗車預約',
    url: 'Inspection',
  },
  {
    id: 7,
    icon: '/images/icon/consultant-info.svg',
    name: '洽詢服務管家',
    url: 'ConsultantInfo',
  },
  {
    id: 8,
    icon: '/images/icon/sales-info.svg',
    name: '洽詢租賃業代',
    url: 'SalesInfo',
  },
];

function CarServiceComponent() {
  const location = useLocation();
  const {
    plateNumber,
    color,
    brand,
    model,
    year,
    displacement,
    isAllowMt,
    isAllowInsp,
    isShowInsp,
  } = location.state || {};
  const page_name = location.pathname.split('/')[4]
    ? location.pathname.split('/')[4]
    : '';
  const firstRowItems = serviceItems.slice(0, 4);
  const secondRowItems = serviceItems.slice(4);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const navigate = useNavigate();

  const handleItemClick = (id, url) => {
    // 如果点击的是已选中的项，则取消选Ｆ择（可以根据需求调整这个行为）
    // console.log(url);
    navigate(`${url}`, {
      state: {
        plateNumber,
        color,
        brand,
        model,
        year,
        displacement,
        isAllowMt,
        isAllowInsp,
        isShowInsp,
      },
    });
    if (selectedItemId === id) {
      setSelectedItemId(null);
    } else {
      setSelectedItemId(id);
    }
  };

  return (
    <>
      <div
        className="space-between px-2 mb-2"
        style={{ wordBreak: 'break-all' }}>
        <div className="my-2">
          <div className="text-body white-font-semibold">{model}</div>
          <div className="heading-s white-font-bold mb-4">{plateNumber}</div>
          <div className="text-sm white-font-normal">
            {color}/{year}/{displacement}cc
          </div>
        </div>
        <img src="/images/illustration/car.svg" alt="Car Illustration" />
      </div>
      <div className="car-service">
        <div className="text-body font-normal">
          <div className="service-grid">
            {serviceItems.map((item) => {
              // 判斷是否顯示‘驗車預約’
              if (item.id === 6 && isShowInsp === false) {
                return;
              } else {
                return (
                  <div
                    key={item.id}
                    className={`service-item ${
                      item.url.toLowerCase() === page_name.toLowerCase()
                        ? 'service-item-tap'
                        : ''
                    }`}
                    onClick={() => handleItemClick(item.id, item.url)}>
                    <img src={item.icon} alt={item.name} />
                    <div className="service-item-text">
                      {[7, 8].includes(item.id) ? (
                        <span style={{ fontSize: '10px' }}>{item.name}</span>
                      ) : (
                        item.name
                      )}
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default CarServiceComponent;
